import "./Contact.css";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebook } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import ContactForm from "./ContactForm";

const Contact = () => {
  const location = useLocation();
  const passedData = location.state?.artwork || null;

  return (
    <div className="bodyContainer">
      {/* Header */}
      <div className="d-flex pt-5">
        <div className="headerContainer w-100" style={{ backgroundColor: "transparent" }}>
          <div className="logoContainer">
            <h1 className="logo">KAIPI MARIA</h1>
          </div>
          <div className="d-flex menuBar">
            <Link to="/" className="nav-item nav-link" id="homeBtn">Home</Link>
            <Link to="/Gallery" className="nav-item nav-link" id="Gallery">Gallery</Link>
            <Link to="/AboutMe" className="nav-item nav-link" id="AboutMeBtn">AboutMe</Link>
            <Link to="/Contact" className="nav-item nav-link active" id="ContactBtn" style={{ textDecoration: "underline" }}>Contact</Link>
            <Link to="/Shop" className="nav-item nav-link" id="ShopBtn">Shop</Link>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="">
        <img className="bgImageCenter" src={`/images/Gallery/the2men1.jpg`} alt="manWatercolor" />
        <div className="row justify-content-center mt-2">
          <div className="col-12 col-md-8 col-lg-4 text-center contact-form-container">
            <h1>Contact Maria</h1>
            <h5 className="mb-5">for info or custom paintings</h5>
            <ContactForm artworkData={passedData} />
            <div id="popUpDiv"></div>
          </div>
        </div>
      </div>

      {/* Social */}
      <div className="block-layout">
        <a href="https://www.instagram.com/kaipimaria_art/" className="socialIcons"><FaInstagram size={30} /></a>
        <a href="https://www.facebook.com/profile.php?id=100012918557813" className="socialIcons"><FaFacebook size={30} /></a>
        <a href="mailto:kaiphmaria001@gmail.com" className="socialIcons"><MdOutlineEmail size={30} /></a>
      </div>
    </div>
  );
};

export default Contact;
